/*
 * Base is the default environment for production.
 */
export default function baseEnv(baseApi: string) {
    return {
        route: {
            baseRoute: "/",
        },
        api: {
            currentVersion: `${baseApi}/v1/v1`,
            errorExample: "https://httpstat.us/520",
            traduzione: `${baseApi}/v1/v1/traduzione`,
            menu: `${baseApi}/v1/v1/menu`,
            contenuto: `${baseApi}/v1/v1/contenuto`,
            tipoRichiedente: `${baseApi}/v1/v1/tipo-richiedente`,
            simulazionePreventivo: `${baseApi}/v1/v1/preventivo/simula`,
            preventivo: `${baseApi}/v1/v1/preventivo`,
            salvaPreventivo: `${baseApi}/v1/v1/preventivo/salva-preventivo`,
            consensoPrivacy: `${baseApi}/v1/v1/consenso-privacy`,
            // login: `${baseApi}/v1/v1/login`,
            refreshToken: `${baseApi}/v1/v1/refresh-token`,
            registrazione: `${baseApi}/v1/v1/cqsonline-registra`,
            confermaRegistrazione: `${baseApi}/v1/v1/registra/conferma`,
            verificaToken: `${baseApi}/v1/v1/registra/verifica-token`,
            verificaRichiesta: `${baseApi}/v1/v1/richiesta/verifica-richiesta`,
            comuniNascita: `${baseApi}/v1/v1/lookup/recupera-comune-nascita`,
            tipoDocumento: `${baseApi}/v1/v1/lookup/recupera-tipi-documento`,
            cittadinanza: `${baseApi}/v1/v1/lookup/recupera-lista-cittadinanze`,
            nazione: `${baseApi}/v1/v1/lookup/recupera-nazioni`,
            tipoIndirizzo: `${baseApi}/v1/v1/lookup/recupera-tipi-indirizzo`,
            amministrazione: `${baseApi}/v1/v1/lookup/recupera-amministrazioni`,
            comuniResidenza: `${baseApi}/v1/v1/lookup/recupera-comune-residenza`,
            fondo: `${baseApi}/v1/v1/lookup/recupera-fondo-pensione`,
            getRichiesta: `${baseApi}/v1/v1/richiesta/recupera-crea-richiesta`,
            saveStepRichiesta: `${baseApi}/v1/v1/richiesta/aggiorna-step`,
            getDatiAnagrafici: `${baseApi}/v1/v1/dati-anagrafici/recupera`,
            saveDatiAnagrafici: `${baseApi}/v1/v1/dati-anagrafici/salva`,
            getDatiReddito: `${baseApi}/v1/v1/dati-reddito/recupera`,
            saveDatiReddito: `${baseApi}/v1/v1/dati-reddito/salva`,
            getAltriPrestiti: `${baseApi}/v1/v1/altri-prestiti/recupera`,
            saveAltriPrestiti: `${baseApi}/v1/v1/altri-prestiti/salva`,
            getDocumenti: `${baseApi}/v1/v1/documenti/recupera`,
            saveDocumento: `${baseApi}/v1/v1/documenti/salva`,
            getDocumentoPianoAmmortamento: `${baseApi}/v1/v1/preventivo/recupera-documento-piano-ammortamento`,
            getDocumento: `${baseApi}/v1/v1/documenti/recupera-documento`,
            deleteDocumento: `${baseApi}/v1/v1/documenti/elimina`,
            avviaProcessoFirma: `${baseApi}/v1/v1/firma/avvia-processo`,
            annullaProcessoFirma: `${baseApi}/v1/v1/firma/annulla-processo`,
            getStatoProcessoFirma: `${baseApi}/v1/v1/firma/stato-processo`,
            avviaProcessoRiconoscimento: `${baseApi}/v1/v1/riconoscimento/avvia-processo`,
            // annullaProcessoRiconoscimento: `${baseApi}/v1/v1/riconoscimento/annulla-processo`,
            getStatoProcessoRiconoscimento: `${baseApi}/v1/v1/riconoscimento/stato-processo`,
            getInfoUtente: `${baseApi}/v1/v1/info-utente`,
            deleteUtente: `${baseApi}/v1/v1/disabilita-utente`,
            credenzialiRecupero: `${baseApi}/v1/v1/credenziali/recupero`,
            credenzialiVerificaToken: `${baseApi}/v1/v1/credenziali/verifica-token`,
            credenzialiAggiorna: `${baseApi}/v1/v1/credenziali/aggiorna`,
            //login: `${baseApi}/login`,
            //contents: `${baseApi}/contents/:sectionId`,
            //content: `${baseApi}/content/:contentId`,
            //campo non necessario
            // qualifica: `${baseApi}/v1/v1/lookup/recupera-tipo-qualifica`,

            //#region CQSonline
            getDocumentiDaCaricareCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/recupera-da-caricare`,
            getDocumentiDaFirmareCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/recupera-da-firmare`,
            saveDocumentoCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/salva`,
            saveSezioneDocumentiCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/salva-sezione`,
            getDocumentoCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/recupera`,
            deleteDocumentoCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/elimina`,
            tipoDocumentoCQSonline: `${baseApi}/v1/v1/cqsonline-lookup/recupera-tipi-documento`,
            getTipoCodiceFiscaleCQSonline: `${baseApi}/v1/v1/cqsonline-lookup/recupera-tipo-codice-fiscale`,
            avvioFirmaCQSonline: `${baseApi}/v1/v1/cqsonline-firma/avvia-processo`,
            annullaFirmaCQSonline: `${baseApi}/v1/v1/cqsonline-firma/annulla-processo`,
            statoFirmaCQSonline: `${baseApi}/v1/v1/cqsonline-firma/stato-processo`,
            avviaRiconoscimentoCQSonline: `${baseApi}/v1/v1/cqsonline-riconoscimento/avvia-riconoscimento`,
            annullaRiconoscimentoCQSonline: `${baseApi}/v1/v1/cqsonline-riconoscimento/annulla-riconoscimento`,
            getStatoRiconoscimentoCQSonline: `${baseApi}/v1/v1/cqsonline-riconoscimento/stato-riconoscimento`,
            credenzialiRecuperoCQSonline: `${baseApi}/v1/v1/cqsonline-credenziali/recupero`,
            credenzialiVerificaTokenCQSonline: `${baseApi}/v1/v1/cqsonline-credenziali/verifica-token`,
            credenzialiAggiornaCQSonline: `${baseApi}/v1/v1/cqsonline-credenziali/aggiorna`,
            creaPraticaCQSonline: `${baseApi}/v1/v1/cqsonline-pratica/crea-pratica`,
            rinvioEmailRegistrazioneCQSonline: `${baseApi}/v1/v1/cqsonline-rinvio-email`,
            verificaPreventivo: `${baseApi}/v1/v1/richiesta/verifica-preventivo`,
            cancellaPreventivoRichiesta: `${baseApi}/v1/v1/richiesta/cancella-preventivo-richiesta`,
            getModalitaErogazione: `${baseApi}/v1/v1/cqsonline-lookup/recupera-modalita-erogazione`,
            getDocumentiIstruttoriaDaFirmareCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/recupera-da-firmare-istruttoria`,
            getInfoPratica: `${baseApi}/v1/v1/cqsonline-pratica/info-pratica`,
            login: `${baseApi}/v1/v1/cqsonline-autenticazione/login`,
            getTipoPensione: `${baseApi}/v1/v1/cqsonline-lookup/recupera-tipologia-pensione`,
            getConfigurazione: `${baseApi}/v1/v1/configurazioni/recupera`,
            getConcludi: `${baseApi}/v1/v1/cqsonline-concludi/recupera-dichiarazioni`,
            saveConcludi: `${baseApi}/v1/v1/cqsonline-concludi/salva`,
            getCategoriaAmministrativa: `${baseApi}/v1/v1/lookup/recupera-categorie-amministrative`,
            getTipologiaImpegni: `${baseApi}/v1/v1/cqsonline-lookup/recupera-tipologie-impegni`,
            getImpegni: `${baseApi}/v1/v1/altri-prestiti/get-impegni`,
            saveImpegni: `${baseApi}/v1/v1/altri-prestiti/salva-impegni`,
            getFiltriPreventivo: `${baseApi}/v1/v1/preventivo/get-filtri`,
            vociAmministrazioneConvenzione: `${baseApi}/v1/v1/lookup/recupera-voci-amministrative`,
            deleteDocumentiGeneratiCQSonline: `${baseApi}/v1/v1/cqsonline-documenti/cancella-documenti-generati`,
            registrazioneAnonima: `${baseApi}/v1/v1/preventivo/salva-recapiti-utente`,
            getQuoteSocietarie: `${baseApi}/v1/v1/cqsonline-lookup/recupera-tipologie-quote-societa`,
            getImportiIntermediari: `${baseApi}/v1/v1/cqsonline-lookup/recupera-importi-rapporti-intermediari`,
            getAdeguataVerifica: `${baseApi}/v1/v1/cqsonline-adeguata-verifica/recupera`,
            saveAdeguataVerifica: `${baseApi}/v1/v1/cqsonline-adeguata-verifica/salva`,
            deleteImpegni: `${baseApi}/v1/v1/altri-prestiti/delete-impegni`,
            getIstitutiFinanziari: `${baseApi}/v1/v1/lookup/recupera-istituto-finanziario`,
            getconsensoPrivacyUtente: `${baseApi}/v1/v1/recupera-consenso-privacy-utente`,
            saveConsesiPrivacyUtente: `${baseApi}/v1/v1/salva-consensi-privacy-utente`,
            trasferisciConsesiCqsWeb: `${baseApi}/v1/v1/cqsonline-documenti/trasferisci-consensi-cqsWeb`,
            // refreshToken: `${baseApi}/v1/v1/cqsonline-autenticazione/refresh-token`,
            // getInfoUtente: `${baseApi}/v1/v1/cqsonline-autenticazione/info-utente`,
            // deleteUtente: `${baseApi}/v1/v1/cqsonline-autenticazione/disabilita-utente`,

            //#endregion CQSonline
        },
        lang: "it-IT",
        isProduction: true,
        isDevelopment: false,
        isTesting: false,
        recaptchaValidation: false,
        recaptchaV2Key: "6LfK6fAUAAAAAHILR9hAHoXG-ITTbwXfX3AeM47q",
        recaptchaV2InvisibleKey: "6LfoTvEUAAAAAOXCzKUuNZn46ysP6MqeLAAbSSVk",
        recaptchaV3Key: "6Lccl64ZAAAAAJgW_Le0jDOWMk85gLX8BnVOqUXY",
        richiestaSteps: ["ANAG", "REDD", "PREST", "DOC", "RICON", "FIRMA", "CONCLUDI", "END"],
        codTipoRichiedentePensionato: "P",
        codTipoRichiedenteDipendentePrivato: "DPR",
        codTipoRichiedenteDipendentePubblico: "DPU",
        codStatoRichiestaInCompilazione: "A",
        codNazioneItalia: "Z000",
        richiestaUploadFileSizeLimit: 5242880, //5mb //2097152, 2mb
        richiestaUploadFileAcceptedTypes: [".pdf", ".jpg", ".png", ".doc", ".docx"],
        richiestaUploadFileMimeTypes: [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        basePathDeploy: "",
        visualizzaCampiBonifico: false,
        visualizzaCampiDatiReddito: false,
        attivaScriptTracciamento: false,
        attivaCalcoloRedditualeID289: false,
        attivaAdeguataVerifica: false,
        attivaCampiNomeCognome: false,
        attivaPreSelezionePensionato: true,
        attivaPreselezioneCatAmmin: false,
        visualizzaAltriImpegniNelTabPrestiti: false,
        attivaGestioneConsensi: false,
        visualizzaDisclaimerPreventivo: false,
    };
}

export type Environment = ReturnType<typeof baseEnv>;
